import { render } from "./empty-state.vue?vue&type=template&id=20af3e91"
import script from "./empty-state.vue?vue&type=script&lang=js"
export * from "./empty-state.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__